import React, { useEffect } from "react";
import { Modal, Form, Input, InputNumber, Select, message } from "antd";
import { createMenu, updateMenu } from "../actions/merchant_actions";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const { Option } = Select;

const MenuFormModal = ({
  visible,
  setVisible,
  initialValues,
  refetchMenus,
}) => {
  const { t } = useTranslation();
  const accUrn = useSelector((state) => state.account.urn);
  const [form] = Form.useForm();

  // Populate form when editing
  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue({
        name: initialValues.data.name,
        currency_code: initialValues.data.currency_code,
        minimum_payment_amount: initialValues.data.minimum_payment_amount,
        maximum_payment_amount: initialValues.data.maximum_payment_amount,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      if (initialValues?.urn) {
        await updateMenu({
          account_urn: accUrn,
          menuUrn: initialValues.urn,
          data: values,
        });
        message.success(t("menu_updated_successfully"));
      } else {
        await createMenu({
          account_urn: accUrn,
          data: values,
        });
        message.success(t("menu_created_successfully"));
      }

      refetchMenus?.();
      setVisible(false);
      form.resetFields();
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        t("something_went_wrong");
      message.error(msg);
    }
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  return (
    <Modal
      title={initialValues ? t("edit_menu") : t("add_new_menu")}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={initialValues ? t("update") : t("submit")}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ currency_code: "GBP" }}
      >
        <Form.Item
          label={t("name")}
          name="name"
          rules={[{ required: true, message: t("please_input_menu_name") }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={t("currency_code")}
          name="currency_code"
          rules={[
            { required: true, message: t("please_select_currency_code") },
          ]}
        >
          <Select>
            <Option value="USD">USD</Option>
            <Option value="EUR">EUR</Option>
            <Option value="GBP">GBP</Option>
            <Option value="EGP">EGP</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label={t("minimum_payment_amount")}
          name="minimum_payment_amount"
          rules={[
            { required: true, message: t("please_enter_minimum_amount") },
          ]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label={t("maximum_payment_amount")}
          name="maximum_payment_amount"
          rules={[
            { required: true, message: t("please_enter_maximum_amount") },
          ]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MenuFormModal;
